import processGaPageLoad from './processGaPageLoad';
import sendToDatalake from './sendToDatalake';
import { GA_SEND_PAGE_VIEW } from './actions';
import { get } from 'lodash';

export function gaPageViewMiddleware(analytics, location) {
    return store => next => action => {
        if (action.type === GA_SEND_PAGE_VIEW) {
            processGaPageLoad({
                state: store.getState(),
                dispatch: store.dispatch,
                analytics,
                location,
            });
        }

        return next(action);
    };
}

export function dataLakeMiddleware(location, doc, initialAnalytics = {}) {
    return store => next => action => {
        const analytics = get(action, 'meta.analytics', null);
        if (analytics) {
            sendToDatalake({
                event: analytics,
                location,
                doc,
                store,
                initialAnalytics,
            });
        }

        return next(action);
    };
}
